export default {
    employ: [],
    active_employ: [],
    certificate: [],
    department: [],
    salary_list: [],
    employ_chekout: [],
    salary_detail: []
}